const WORKER_URL =
  process.env.NODE_ENV === "development"
    ? "/api/form-handler"
    : (process.env.REACT_APP_WORKER_URL ?? "");

const NETWORK_ERROR_MESSAGE =
  "Your inquiry may have been sent, but the confirmation did not come back. Please wait a few minutes and check email before submitting again.";

type FormType = "class" | "class-booking" | "order";

function isBrowserNetworkError(error: unknown) {
  return (
    error instanceof TypeError &&
    /failed to fetch|networkerror when attempting to fetch resource|load failed/i.test(
      error.message,
    )
  );
}

async function parseWorkerResponse(response: Response) {
  let result: { success?: boolean; message?: string } = {};
  try {
    result = await response.json();
  } catch {
    result = {};
  }

  if (!response.ok || !result.success) {
    throw new Error(result.message || "Form submission failed.");
  }

  return result;
}

async function postToWorker(init: RequestInit) {
  if (!WORKER_URL) {
    throw new Error("Missing REACT_APP_WORKER_URL");
  }

  try {
    const response = await fetch(WORKER_URL, init);
    return await parseWorkerResponse(response);
  } catch (error) {
    if (isBrowserNetworkError(error)) {
      throw new Error(NETWORK_ERROR_MESSAGE);
    }
    throw error;
  }
}

export async function submitWorkerJsonForm(
  formType: FormType,
  payload: Record<string, unknown>,
) {
  return postToWorker({
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      formType,
      ...payload,
    }),
  });
}

export async function submitWorkerMultipartForm(formData: FormData) {
  return postToWorker({
    method: "POST",
    body: formData,
  });
}
